<template>
<div class="chapter">
<div class="inner_page">
<div><a id="quotes"></a></div>
<div class="margin"></div>
<h4 class="parttitle"><a href="#/html/003_toc#quotes_">The Quotes</a></h4>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_quotes.vue?4951f7d1